import './webComponentsFix';
import { applySurveyJsBackspaceFix } from './surveyJsBackspaceFix';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// import "custom-survey-core/defaultV2.css";
// import "custom-survey-creator-core/survey-creator-core.css";

applySurveyJsBackspaceFix();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
